import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import OutlinedInput from '@material-ui/core/OutlinedInput';
//apis
import { GetSubCatsForddl, UpdateItem, InsertItem, GetCatFromSubCat } from '../apis/ItemsAPI';
import { GetSubCategorys } from '../apis/SubCategoriesApis';
import DisplayAlert from '../components/DisplayAlert'
import CircularProgress from '@material-ui/core/CircularProgress';
import { uploadImage, DeleteImage } from '../apis/CategoriesApis';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';


const useStylesddl = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 180,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

export default function DialogForItem({ isUpdate, getData, ItemRow, openModal, handleCloseModal, OpenSnackBarForMsg }) {
    const [openAlert, setopenAlert] = useState(false)
    const [AlertMessage, setAlertMessage] = useState("")
    const [loading, setLoading] = useState(false);
    const [SubCategorysddl, setSubCategorysddl] = useState([])
    const [SelectedSubCategory, setSelectedSubCategory] = useState("")
    const [ItemDescriptionAr, setItemDescriptionAr] = useState("")
    const [ItemDescription, setItemDescription] = useState("")
    const [ItemPriceEdit, setItemPriceEdit] = useState("")
    const [ItemArabicNameEdit, setItemArabicNameEdit] = useState("")
    const [ItemEnglishNameEdit, setItemEnglishNameEdit] = useState("")
    const [images, setimages] = useState()
    const [OrderNumber, setOrderNumber] = useState("")
    const [IsStateItemFreePrice, setStateIsItemFreePrice] = useState(false);
    const [IsStateItemVisible, setIsStateItemVisible] = useState(true);
    const [ChoiceNameState, setChoiceNameState] = React.useState([]);
    const [ChoiceRecState, setChoiceRecState] = useState(false)
    const [ChoiceSpicyState, setChoiceSpicyState] = useState(false)
    const [ChoicePopulaStater, setChoicePopularState] = useState(false)
    const [ChoiceNewState, setChoiceNewState] = useState(false)
    const [ChoiceVeganState, setChoiceVeganState] = useState(false)
    const [ChoiceOfferState, setChoiceOfferState] = useState(false)

    // Structured editor used when the item has multiple/free prices.
    const [FreePriceOptions, setFreePriceOptions] = useState([
        { size: '', price: '' }
    ]);

    const SizeSuggestions = [
        'Small',
        'Medium',
        'Large',
        'Extra Large',
        'Half Portion',
        'Full Portion',
        '250 ml',
        '330 ml',
        '500 ml',
        '1 Litre'
    ];

    const classesddl = useStylesddl();

    const parseFreePriceOptions = (value) => {
        const rawValue = value?.toString().trim();

        if (!rawValue) {
            return [{ size: '', price: '' }];
        }

        return rawValue
            .split('|')
            .map(option => option.trim())
            .filter(Boolean)
            .map(option => {
                // Preferred saved format: Size:Price
                const colonIndex = option.indexOf(':');

                if (colonIndex >= 0) {
                    return {
                        size: option.substring(0, colonIndex).trim(),
                        price: option.substring(colonIndex + 1).trim()
                    };
                }

                // Backward compatibility for values such as "Small 7.00$".
                const match = option.match(
                    /^(.*?)\s+(\d+(?:[.,]\d+)?\s*[^\d\s]*)$/
                );

                if (match) {
                    return {
                        size: match[1].trim(),
                        price: match[2].trim()
                    };
                }

                // A value such as "1.00" remains a price without a size.
                return {
                    size: '',
                    price: option
                };
            });
    };

    const buildFreePriceValue = () => {
        return FreePriceOptions
            .map(option => ({
                size: option.size.trim(),
                price: option.price.trim()
            }))
            .filter(option => option.price)
            .map(option => option.size
                ? `${option.size}:${option.price}`
                : option.price
            )
            .join('|');
    };

    const handleFreePriceOptionChange = (index, field, value) => {
        setFreePriceOptions(previousOptions =>
            previousOptions.map((option, optionIndex) =>
                optionIndex === index
                    ? { ...option, [field]: value }
                    : option
            )
        );
    };

    const addFreePriceOption = () => {
        setFreePriceOptions(previousOptions => [
            ...previousOptions,
            { size: '', price: '' }
        ]);
    };

    const removeFreePriceOption = (index) => {
        setFreePriceOptions(previousOptions => {
            const updatedOptions = previousOptions.filter(
                (_, optionIndex) => optionIndex !== index
            );

            return updatedOptions.length > 0
                ? updatedOptions
                : [{ size: '', price: '' }];
        });
    };

    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;

        setStateIsItemFreePrice(checked);

        if (checked) {
            setFreePriceOptions(parseFreePriceOptions(ItemPriceEdit));
        } else {
            // Preserve a single price when switching back to normal-price mode.
            const completedOptions = FreePriceOptions.filter(
                option => option.price.trim()
            );

            setItemPriceEdit(
                completedOptions.length === 1
                    ? completedOptions[0].price.trim()
                    : ''
            );
        }
    };

    const handleCheckboxChangeVisibleItem = () => {
        setIsStateItemVisible(!IsStateItemVisible);
    };

    useEffect(() => {
        getSubCategoriesforddlAPI();
        if (isUpdate && ItemRow) {
            setSelectedSubCategory(ItemRow.SubCatId);
            setItemArabicNameEdit(ItemRow.ItemNameSecondlang);
            setItemEnglishNameEdit(ItemRow.ItemNameFirstLang)
            setItemPriceEdit(ItemRow.ItemPrice)
            setItemDescription(ItemRow.ItemDescFirstLang)
            setItemDescriptionAr(ItemRow.ItemDescSecondlang)
            setOrderNumber(ItemRow.ItemOrderNbr);
            setStateIsItemFreePrice(ItemRow.IsItemFreePrice);

            if (ItemRow.IsItemFreePrice) {
                setFreePriceOptions(parseFreePriceOptions(ItemRow.ItemPrice));
            } else {
                setFreePriceOptions([
                    {
                        size: '',
                        price: ItemRow.ItemPrice?.toString() || ''
                    }
                ]);
            }
            setChoiceRecState(ItemRow?.RecommendedChoice)
            setChoiceSpicyState(ItemRow?.SpicyChoice)
            setChoicePopularState(ItemRow?.PopularChoice)
            setChoiceNewState(ItemRow?.NewChoice)
            setChoiceVeganState(ItemRow?.VeganChoice)
            setChoiceOfferState(ItemRow?.OfferChoice)
            setIsStateItemVisible(ItemRow?.IsItemVisible)

            const arrayConcatedChoices = [
                ItemRow?.RecommendedChoice ? 'Rec 👑' : '',
                ItemRow?.SpicyChoice ? 'Spicy 🌶️' : '',
                ItemRow?.PopularChoice ? 'Popular ⭐' : '',
                ItemRow?.NewChoice ? 'New 🆕' : '',
                ItemRow?.VeganChoice ? 'Vegan 🌿' : '',
                ItemRow?.OfferChoice ? 'Offre 📌' : '',
            ].filter(Boolean);
            setChoiceNameState(arrayConcatedChoices);

        }
    }, [ItemRow, getData])

    const update = async () => {
        return await callbackEdit({
            ItemId: ItemRow.ItemId,
            SubCatId: SelectedSubCategory,
            ItemOrderNbr: OrderNumber,
            ItemNameFirstLang: ItemEnglishNameEdit,
            ItemNameSecondlang: ItemArabicNameEdit,
            ItemDescFirstLang: ItemDescription,
            ItemDescSecondlang: ItemDescriptionAr,
            ItemPrice: IsStateItemFreePrice
                ? buildFreePriceValue()
                : ItemPriceEdit,
            IsItemFreePrice: IsStateItemFreePrice,
            RecommendedChoice: ChoiceRecState,
            PopularChoice: ChoicePopulaStater,
            SpicyChoice: ChoiceSpicyState,
            NewChoice: ChoiceNewState,
            VeganChoice: ChoiceVeganState,
            OfferChoice: ChoiceOfferState,
            IsItemVisible: IsStateItemVisible,
        })
    }

    const handleColseAlert = () => {
        setopenAlert(false);
    };

    const insert = async () => {
        return await callbackInsert({
            SubCatId: SelectedSubCategory,
            ItemOrderNbr: OrderNumber,
            ItemNameFirstLang: ItemEnglishNameEdit,
            ItemNameSecondlang: ItemArabicNameEdit,
            ItemDescFirstLang: ItemDescription,
            ItemDescSecondlang: ItemDescriptionAr,
            ItemPrice: IsStateItemFreePrice
                ? buildFreePriceValue()
                : ItemPriceEdit,
            IsItemFreePrice: IsStateItemFreePrice,
            RecommendedChoice: ChoiceRecState,
            PopularChoice: ChoicePopulaStater,
            SpicyChoice: ChoiceSpicyState,
            NewChoice: ChoiceNewState,
            VeganChoice: ChoiceVeganState,
            OfferChoice: ChoiceOfferState,
            IsItemVisible: IsStateItemVisible,
        })

    }
    const ClearFields = () => {
        setItemArabicNameEdit("");
        setItemEnglishNameEdit("");
        setSelectedSubCategory("");
        setItemPriceEdit("");
        setItemDescription("");
        setimages("");
        setOrderNumber("");
        setItemDescriptionAr("");
        setStateIsItemFreePrice(false);
        setIsStateItemVisible(true);
        setChoiceNameState([]);

        setChoiceRecState(false)
        setChoiceSpicyState(false)
        setChoicePopularState(false)
        setChoiceNewState(false)
        setChoiceVeganState(false)
        setChoiceOfferState(false)
        setFreePriceOptions([{ size: '', price: '' }]);

    };


    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    const handleChangeChoiceddl = (event) => {
        const { value } = event.target;

        //alert(value)
        // Update the state based on the selected value
        setChoiceNameState(value);

        // Update the individual checkbox states
        setChoiceRecState(value.includes("Rec 👑"));
        setChoiceSpicyState(value.includes("Spicy 🌶️"));
        setChoicePopularState(value.includes("Popular ⭐"));
        setChoiceNewState(value.includes("New 🆕"));
        setChoiceVeganState(value.includes("Vegan 🌿"));
        setChoiceOfferState(value.includes("Offre 📌"));
    };

    const callbackInsert = async (data) => {
        const InsertRes = await InsertItem(data);
        const CnstErrorMsg = InsertRes?.Error?.Message;
        if (CnstErrorMsg) {
            OpenSnackBarForMsg("Failed to Insert Item, " + InsertRes?.Error?.Message)
            setLoading(false);
        }
        else {
            if (images)
                await uploadImage(images, "Items", InsertRes, JSON.stringify(data))

            await getData()
            handleCloseModal();
            OpenSnackBarForMsg("Item Inserted successfully ");
            ClearFields();
            setLoading(false);
        }
    }

    const callbackEdit = async (data) => {
        const UpdateRes = await UpdateItem(data);
        const CnstErrorMsg = UpdateRes?.Error?.Message;
        if (CnstErrorMsg) {
            OpenSnackBarForMsg("Failed to update item, " + UpdateRes?.Error?.Message)
            setLoading(false);
        }
        else {
            const ImageID = ItemRow.Image?.id;
            //check if user has been upload a image on update mode , so we need to delete the old one and reupload a new image
            if (ImageID && images) {
                await (DeleteImage(({ RelatedId: ImageID, RelatedType: "Items" })))
            }
            if (images)
                await uploadImage(images, "Items", data.ItemId, JSON.stringify(data))
            await getData()
            handleCloseModal();
            OpenSnackBarForMsg("Item Updated successfully ");
            ClearFields();
            setLoading(false);
        }
    }


    const submit = async () => {
        if (SelectedSubCategory === '' || (!ItemEnglishNameEdit && !ItemArabicNameEdit))
            return alert('Please Check mandatory Fields')

        if (IsStateItemFreePrice) {
            const incompleteOption = FreePriceOptions.some(
                option => option.size.trim() && !option.price.trim()
            );

            if (incompleteOption) {
                return alert('Please enter a price for every selected size');
            }

            if (!buildFreePriceValue()) {
                return alert('Please enter at least one price');
            }
        } else if (!ItemPriceEdit?.toString().trim()) {
            return alert('Please enter the item price');
        }

        setLoading(true);
        if (isUpdate) {
            await update()
            // setLoading(false);
        }
        else {
            await insert()
            // setLoading(false);
        }
    }

    const onImageChange = event => {
        setimages(event.target.files[0]);
    };

    const handleChangeddl = (event) => {
        setSelectedSubCategory(event.target.value);
        // console.log("selected", event.target.value)
    };

    const getSubCategoriesforddlAPI = async () => {
        const result = await GetSubCategorys({ "RestId": localStorage.getItem("RestaurantId") });
        console.log("result", result)
        setSubCategorysddl(result?.Dt);
    }
    return (
        <div>


            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth="md"
            >
                <DialogTitle id="form-dialog-title">Item Info</DialogTitle>
                <DialogContent>
                    <form  >

                        <FormControl className={classesddl.formControl} required >
                            <InputLabel id="demo-simple-select-label">Sub-Category</InputLabel>
                            <Select
                                autoFocus
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={SelectedSubCategory}
                                onChange={handleChangeddl}     >
                                {/* {console.log("ddddd",SubCategorysddl)} */}
                                {SubCategorysddl
                                    ?.slice()
                                    .sort((a, b) => {
                                        const categoryOrderA = Number(a.OrderNbr || 0);
                                        const categoryOrderB = Number(b.OrderNbr || 0);

                                        if (categoryOrderA !== categoryOrderB) {
                                            return categoryOrderA - categoryOrderB;
                                        }

                                        const subCategoryOrderA = Number(a.SubCatOrderNbr || 0);
                                        const subCategoryOrderB = Number(b.SubCatOrderNbr || 0);

                                        return subCategoryOrderA - subCategoryOrderB;
                                    })
                                    .map(item => (
                                        <MenuItem
                                            key={item.SubCatId}
                                            value={item.SubCatId}
                                            style={{
                                                display: "block",
                                                paddingTop: "10px",
                                                paddingBottom: "10px"
                                            }}
                                        >
                                            <ListItemText
                                                primary={`${item.CatNameFirstLang} → ${item.SubCatNameFirstLang}`}
                                                primaryTypographyProps={{
                                                    style: {
                                                        direction: "ltr",
                                                        textAlign: "left",
                                                        fontSize: "15px"
                                                    }
                                                }}
                                                secondary={
                                                    <span
                                                        dir="rtl"
                                                        style={{
                                                            display: "block",
                                                            width: "100%",
                                                            marginTop: "3px",
                                                            textAlign: "right",
                                                            fontSize: "13px"
                                                        }}
                                                    >
                                                        {item.CatNameSecondlang} ← {item.SubCatNameSecondlang}
                                                    </span>
                                                }
                                            />
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                        <br />
                        <TextField
                            margin="dense"
                            id="txtItemNameEng"
                            label="Item English Name"
                            value={ItemEnglishNameEdit}
                            onChange={(event) => setItemEnglishNameEdit(event.target.value)}
                            required
                        />
                        <br />
                        <TextField
                            margin="dense"
                            id="txtItemNameAr"
                            label="Item SecondLang Name"
                            value={ItemArabicNameEdit}
                            onChange={(event) => setItemArabicNameEdit(event.target.value)}
                            required
                        />
                        <br />
                        <div style={{ marginTop: '16px' }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={IsStateItemFreePrice}
                                        onChange={handleCheckboxChange}
                                        color="primary"
                                    />
                                }
                                label="Multiple sizes / free price"
                            />

                            {!IsStateItemFreePrice ? (
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="txtItemPrice"
                                    label="Item Price"
                                    value={ItemPriceEdit}
                                    onChange={(event) => setItemPriceEdit(event.target.value)}
                                    required
                                />
                            ) : (
                                <div className="free-price-editor">
                                    <div className="free-price-editor-header">
                                        <div>
                                            <strong>Size and price options</strong>
                                            <div className="free-price-editor-help">
                                                Select a suggested size or type a custom one.
                                            </div>
                                        </div>

                                        <Button
                                            type="button"
                                            color="primary"
                                            startIcon={<AddCircleOutlineIcon />}
                                            onClick={addFreePriceOption}
                                        >
                                            Add size
                                        </Button>
                                    </div>

                                    {FreePriceOptions.map((option, index) => (
                                        <div
                                            key={`free-price-option-${index}`}
                                            className="free-price-editor-row"
                                        >
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                label="Size"
                                                placeholder="Small, Medium, 1 Litre..."
                                                value={option.size}
                                                onChange={(event) =>
                                                    handleFreePriceOptionChange(
                                                        index,
                                                        'size',
                                                        event.target.value
                                                    )
                                                }
                                                inputProps={{
                                                    list: `size-suggestions-${index}`
                                                }}
                                                className="free-price-size-field"
                                            />

                                            <datalist id={`size-suggestions-${index}`}>
                                                {SizeSuggestions.map(size => (
                                                    <option key={size} value={size} />
                                                ))}
                                            </datalist>

                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                label="Price"
                                                placeholder="Example: 8.00$"
                                                value={option.price}
                                                onChange={(event) =>
                                                    handleFreePriceOptionChange(
                                                        index,
                                                        'price',
                                                        event.target.value
                                                    )
                                                }
                                                className="free-price-price-field"
                                                required
                                            />

                                            <IconButton
                                                type="button"
                                                aria-label="Remove size"
                                                onClick={() => removeFreePriceOption(index)}
                                                disabled={FreePriceOptions.length === 1}
                                            >
                                                <DeleteOutlineIcon />
                                            </IconButton>
                                        </div>
                                    ))}

                                    <div className="free-price-preview">
                                        <strong>Saved value:</strong>{' '}
                                        {buildFreePriceValue() || 'No options entered'}
                                    </div>
                                </div>
                            )}
                        </div>

                        <br />
                        <TextField
                            className="MultiLinesTextBox"
                            margin="dense"
                            id="txtItemDesc"
                            label="Item Descirption Eng"
                            multiline
                            rows={8}
                            value={ItemDescription}
                            onChange={(event) => setItemDescription(event.target.value)}
                            required
                        />
                        <br />
                        <TextField
                            className="MultiLinesTextBox"
                            margin="dense"
                            id="txtItemDescAt"
                            label="Item Descirption Sec"
                            multiline
                            rows={8}
                            value={ItemDescriptionAr}
                            onChange={(event) => setItemDescriptionAr(event.target.value)}
                            required
                        />
                        <br />
                        <div>
                            <InputLabel id="demo-multiple-checkbox-label">Top Choices</InputLabel>
                            <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={ChoiceNameState}
                                onChange={handleChangeChoiceddl}
                                input={<OutlinedInput label="Top Choices" />}
                                renderValue={(selected) => selected.join(', ')}
                                MenuProps={MenuProps}  >

                                <MenuItem key={"Rec 👑"} value={"Rec 👑"}>
                                    <Checkbox checked={ChoiceRecState} />
                                    <ListItemText primary={"Rec 👑"} />
                                </MenuItem>

                                <MenuItem key={"Spicy 🌶️"} value={"Spicy 🌶️"}>
                                    <Checkbox checked={ChoiceSpicyState} />
                                    <ListItemText primary={"Spicy 🌶️"} />
                                </MenuItem>

                                <MenuItem key={"Popular ⭐"} value={"Popular ⭐"}>
                                    <Checkbox checked={ChoicePopulaStater} />
                                    <ListItemText primary={"Popular ⭐"} />
                                </MenuItem>

                                <MenuItem key={"New 🆕"} value={"New 🆕"}>
                                    <Checkbox checked={ChoiceNewState} />
                                    <ListItemText primary={"New 🆕"} />
                                </MenuItem>

                                <MenuItem key={"Vegan 🌿"} value={"Vegan 🌿"}>
                                    <Checkbox checked={ChoiceVeganState} />
                                    <ListItemText primary={"Vegan 🌿"} />
                                </MenuItem>

                                <MenuItem key={"Offre 📌"} value={"Offre 📌"}>
                                    <Checkbox checked={ChoiceOfferState} />
                                    <ListItemText primary={"Offre 📌"} />
                                </MenuItem>

                            </Select>
                        </div>

                        <br />
                        <TextField
                            type="number"
                            margin="dense"
                            id="txtOrder"
                            label="Order Nbr"
                            value={OrderNumber}
                            onChange={(event) => setOrderNumber(event.target.value)}
                            required
                        />
                        <br />
                        <br />
                        <FormGroup>
                            <InputLabel id="demo-multiple-checkbox-label">Visible
                                <Checkbox checked={IsStateItemVisible} onChange={() => handleCheckboxChangeVisibleItem()} /> </InputLabel>
                        </FormGroup>

                        <br />
                        <input
                            accept="image/*"
                            name="file"
                            id="contained-button-file"
                            single
                            type="file"
                            onChange={onImageChange}
                        />
                    </form>
                    <br></br>
                </DialogContent>
                <DialogActions>
                    <div
                        style={{
                            position: 'absolute', left: '50%', top: '60%',
                            transform: 'translate(-50%, -50%)'
                        }}
                    >
                        {loading && <CircularProgress size={70} thickness={3} style={{ 'color': 'red' }} />}
                    </div>


                    <Button onClick={handleCloseModal} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={(e) => submit()} color="primary" type="submit">
                        {isUpdate ? 'Update' : 'Add'}
                    </Button>
                </DialogActions>
                <DisplayAlert open={openAlert} message={AlertMessage} close={handleColseAlert} />
            </Dialog>
        </div>
    )
}
